module.exports = __webpack_public_path__ + "static/media/chart-bar-on.3a908ace.svg";